function ArrowLeft({ className }: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className={`h-5 w-5 ${className}`}
      stroke="#b4b4b4"
      fill="currentColor"
    >
      <path
        d="M16 12H0M0 12L4 8M0 12L4 16"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default ArrowLeft;
